export const ALCHEMY_NETWORKS = {
  // Mainnets
  homestead: {
    name: 'Ethereum Mainnet',
    rpcUrl: 'https://eth-mainnet.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 1,
  },
  polygon: {
    name: 'Polygon PoS',
    rpcUrl: 'https://polygon-mainnet.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 137,
  },
  optimism: {
    name: 'OP Mainnet',
    rpcUrl: 'https://opt-mainnet.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 10,
  },
  arbitrum: {
    name: 'Arbitrum One',
    rpcUrl: 'https://arb-mainnet.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 42161,
  },
  base: {
    name: 'Base Mainnet',
    rpcUrl: 'https://base-mainnet.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 8453,
  },
  worldchain: {
    name: 'World Chain',
    rpcUrl: 'https://world-mainnet.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN', // Placeholder, verificar soporte
    chainId: 480, // Placeholder, verificar chainId real
  },
  // Testnets
  sepolia: {
    name: 'Sepolia (Ethereum Testnet)',
    rpcUrl: 'https://eth-sepolia.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 11155111,
  },
  polygon_amoy: {
    name: 'Polygon Amoy (Testnet)',
    rpcUrl: 'https://polygon-amoy.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 80002,
  },
  optimism_sepolia: {
    name: 'OP Sepolia (Testnet)',
    rpcUrl: 'https://opt-sepolia.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 11155420,
  },
  arbitrum_sepolia: {
    name: 'Arbitrum Sepolia (Testnet)',
    rpcUrl: 'https://arb-sepolia.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 421614,
  },
  base_sepolia: {
    name: 'Base Sepolia (Testnet)',
    rpcUrl: 'https://base-sepolia.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN',
    chainId: 84532,
  },
  worldchain_testnet: {
    name: 'World Chain Testnet',
    rpcUrl: 'https://world-sepolia.g.alchemy.com/v2/_epLaBGqUQVpDDeIulROEOcMHWsCNvjN', // Placeholder, verificar soporte
    chainId: 4801, // Placeholder, verificar chainId real
  },
};

export const getAlchemyRpcUrl = (network) => {
  if (!network) {
    throw new Error('Network parameter is required');
  }

  const networkConfig = ALCHEMY_NETWORKS[network];
  if (!networkConfig) {
    throw new Error(`Unsupported network: ${network}. Supported networks: ${Object.keys(ALCHEMY_NETWORKS).join(', ')}`);
  }

  if (!networkConfig.rpcUrl) {
    throw new Error(`RPC URL not configured for network: ${networkConfig.name}. Please provide a valid Alchemy API key.`);
  }

  return networkConfig.rpcUrl;
};

